import type { User } from '@gmn-portal/backend';
import { redirect } from 'react-router-dom';

export const redirectBasedOnRole = (user: User) => {
  if (user.role === 'customer-admin') {
    return redirect('/c');
  }
  if (user.role === 'gmn-admin') {
    return redirect('/gmn');
  }
  return redirect('/auth/login');
};

export const publicRoute = (user: User | null) => {
  return user ? redirectBasedOnRole(user) : null;
};

export const privateRoute =
  (allowedRoles: Array<'gmn-admin' | 'customer-admin'>) => (user: User | null) => {
    if (!user) {
      return redirect('/auth/login');
    }
    if (user.role !== 'gmn-admin' && user.role !== 'customer-admin') {
      return redirect('/auth/login');
    }
    if (!allowedRoles.includes(user.role)) {
      return redirectBasedOnRole(user);
    }
    return null;
  };

export const unknownRoute = (user: User | null) => {
  return user ? redirectBasedOnRole(user) : redirect('/auth/login');
};
